import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import TrustBadge from './components/TrustBadge/TrustBadge';
import Categories from './components/Categories/Categories';
import About from './components/About/About';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';
import FixedBottomButtons from './components/FixedBottomButtons/FixedBottomButtons';
import './App.css';

// Main content component
const MainContent = () => {
  return (
    <>
      <Header />
      <Hero />
      <TrustBadge />
      <Categories />
      <About />
      <Testimonials />
      <FAQ />
      <Footer />
      <FixedBottomButtons />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/pune" element={<MainContent />} />
          <Route path="/noida" element={<MainContent />} />
          <Route path="/" element={<MainContent />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
